<div class="formulario">
  <div class="container">
    <form class="myForm" [formGroup]="articuloForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <div class="container">
        <div class="row">
          <!-- Fotos -->
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Foto</label>
              <div class="row">
                <div class="col-8">

                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,1)">
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(1)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-danger" (click)="deleteImagen(1)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="form-group text-center" *ngIf="imgURL">


              <img [src]="imgURL" *ngIf="imgURL" class="image_articulo">

            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Foto</label>
              <div class="row">
                <div class="col-8">

                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,2)">
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(2)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-danger" (click)="deleteImagen(2)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="form-group text-center" *ngIf="imgURL2">


              <img [src]="imgURL2" *ngIf="imgURL2" class="image_articulo">

            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Foto</label>
              <div class="row">
                <div class="col-8">

                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,3)">
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(3)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-danger" (click)="deleteImagen(3)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="form-group text-center" *ngIf="imgURL3">


              <img [src]="imgURL3" *ngIf="imgURL3" class="image_articulo">

            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Foto</label>
              <div class="row">
                <div class="col-8">

                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,4)">
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(4)" type="button">
                    <i class="fa fa-camera"></i>
                  </button>
                </div>
                <div class="col-2" style="text-align: right;">
                  <button class="btn btn-danger" (click)="deleteImagen(4)" type="button">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="form-group text-center" *ngIf="imgURL4">


              <img [src]="imgURL4" class="image_articulo" *ngIf="imgURL4">

            </div>
          </div>
          <div class="col-lg-6">

          </div>

        </div>

        <div class="row">
          <div class="col-lg-4">
            <div class="form-group">
              <label>Proveedor</label>
              <app-generic-dropdown [database]="'wproveedores'" [item]="this.articuloForm.get('id_proveedor').value"
                (selectItem)="setProveedor($event)">
              </app-generic-dropdown>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Nombre</label>
              <input class="form-control" type="text" formControlName="nombre">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Descripción</label>
              <input class="form-control" type="text" formControlName="descripcion">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="">Color</label>
              <input class="form-control" type="text" formControlName="color">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="">Maceta (CM / Litros)</label>
              <input class="form-control" type="text" formControlName="maceta">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="">Tamaño (Altura / calibre)</label>
              <input class="form-control" type="text" formControlName="tamano">
            </div>
          </div>
          <div class="col-lg-3">
            <div class="form-group">
              <label for="">Peso (Kg)</label>
              <input class="form-control alider" type="number" formControlName="peso">
            </div>
          </div>

          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Unidades/caja</label>
              <input class="form-control alider" type="number" formControlName="unidades_caja">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Unidades/piso</label>
              <input class="form-control alider" type="number" formControlName="unidades_piso">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Unidades/cc</label>
              <input class="form-control alider" type="number" formControlName="unidades_cc">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Pisos/cc</label>
              <input class="form-control alider" type="number" formControlName="pisos_cc">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">EAN vivero</label>
              <input class="form-control" type="text" formControlName="ean_vivero">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Fecha creación</label>
              <p-calendar #fecha name="fecha" formControlName="fecha_creacion" [locale]="es"
                dateFormat="dd/mm/yy"></p-calendar>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Precio neto vivero</label>
              <input class="form-control alider" type="number" formControlName="precio_neto_vivero">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Precio etiquetado por artículo</label>
              <input class="form-control alider" type="number" formControlName="precio_etiqueta_articulo">
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group">
              <label for="">Precio comisión por carro mix</label>
              <input class="form-control alider" type="number" formControlName="precio_comision_carro">
            </div>
          </div>

          <div class="row mt-5 mr-1 ml-1 mb-5">
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Genérico</label>
                <input class="form-control" type="text" formControlName="codigo_generico">
              </div>
            </div>
            <div class="col-lg-4"></div>
            <div class="col-lg-4"></div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Dehner</label>
                <input class="form-control" type="text" formControlName="codigo_dehner">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Schmid</label>
                <input class="form-control" type="text" formControlName="codigo_schmid">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Migros</label>
                <input class="form-control" type="text" formControlName="codigo_migros">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Irsslinger</label>
                <input class="form-control" type="text" formControlName="codigo_irsslinger">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Blume2000</label>
                <input class="form-control" type="text" formControlName="codigo_blume2000">
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label for="">Código Landgard</label>
                <input class="form-control" type="text" formControlName="codigo_landgard">
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Cantidad reservada</label>
              <input class="form-control alider" type="number" formControlName="cantidad_reservada">
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label for="">Cantidad cargada</label>
              <input class="form-control alider" type="number" formControlName="cantidad_cargada">
            </div>
          </div>
        </div>

      </div>
      <br>

      <div class="botones">
        <button type="button" class="btn btn-warning" (click)="regresar()"><i class="fa fa-chevron-left"
            aria-hidden="true"></i> Volver</button>
        <button type="submit" class="btn btn-success" [disabled]="articuloForm.invalid || noGrabar"><i
            class="fa fa-save" aria-hidden="true"></i> Enviar</button>
      </div>

    </form>
  </div>
</div>
<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-dialog [(visible)]="showCamera">
  <div *ngIf="showCamera">
    <app-camera (sendImage)="getImage($event)" (closeCamera)="closeDialog($event)" [fileName]='fileName'
      [numberPhoto]='numberPhoto'></app-camera>
  </div>

</p-dialog>